﻿import { ListResponse, ServiceOptions, serviceRequest } from "@serenity-is/corelib";
import { SqlProcLookupListParametersRequest } from "./SqlProcLookupListParametersRequest";
import { SqlProcLookupParameter } from "./SqlProcLookupParameter";

export namespace SqlProcLookupParameterService {
    export const baseUrl = 'Data/SqlProcLookupParameter';

    export declare function ListParameters(request: SqlProcLookupListParametersRequest, onSuccess?: (response: ListResponse<SqlProcLookupParameter>) => void, opt?: ServiceOptions<any>): PromiseLike<ListResponse<SqlProcLookupParameter>>;

    export const Methods = {
        ListParameters: "Data/SqlProcLookupParameter/ListParameters"
    } as const;

    [
        'ListParameters'
    ].forEach(x => {
        (<any>SqlProcLookupParameterService)[x] = function (r, s, o) {
            return serviceRequest(baseUrl + '/' + x, r, s, o);
        };
    });
}